import './UserMenuIcon.scss';

import { LoadingOutlined, LogoutOutlined } from '@ant-design/icons';
import { useLogout } from '@refinedev/core';
import { Avatar, Button, Flex, Popover } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import { useUiContext } from '@/contexts/UiContext';
import { useUserContext } from '@/contexts/UserContext';
import User from '@/model/General/User';
import { UserWorkAreaString } from '@/model/General/UserWorkArea';

interface UserMenuIconProps {
  user?: User;
}

const UserMenuIcon = (props: UserMenuIconProps) => {
  const { t } = useTranslation();
  const { isMobile } = useUiContext();
  const { devOptions } = useUserContext();
  const { user } = props;
  const { mutate: logout } = useLogout();
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const userNameInitials = useMemo(
    () => '' + user?.firstName?.charAt(0) + user?.lastName?.charAt(0),
    [user],
  );
  // Reutilizamos el mismo release que reporta Sentry para mostrar la version cargada en la UI.
  const sentryRelease = import.meta.env.VITE_SENTRY_RELEASE?.trim();
  // Si el release es un SHA completo, mostramos una version corta como referencia visual similar a GitLab.
  const sentryReleaseDisplay =
    sentryRelease && /^[0-9a-f]{40}$/i.test(sentryRelease)
      ? sentryRelease.slice(0, 8)
      : sentryRelease;

  return (
    <div className="UserMenuIcon">
      <Popover
        placement="bottomRight"
        content={
          <Flex vertical gap={6}>
            {isMobile && devOptions && (
              <AntdSelect
                size="small"
                value={devOptions.selectedWorkArea}
                onChange={devOptions.handleChangeWorkArea}
                options={Object.keys(UserWorkAreaString).map(v => ({
                  label: UserWorkAreaString[v as keyof typeof UserWorkAreaString],
                  value: v,
                }))}
              />
            )}
            <Button type="text" onClick={() => logout()} icon={<LogoutOutlined />}>
              {t('Cerrar sesión')}
            </Button>

            <div className="LayoutHeaderReleaseTag" title={sentryRelease}>
              {t('Release')}: {sentryReleaseDisplay ? sentryReleaseDisplay : 'Local'}
            </div>
          </Flex>
        }
        open={openUserMenu}
        onOpenChange={(visible: boolean) => setOpenUserMenu(visible)}
        trigger="click">
        <Avatar size="small" className="UserMenuIconAvatar">
          {user && userNameInitials != '' ? userNameInitials.toUpperCase() : <LoadingOutlined />}
        </Avatar>
      </Popover>
    </div>
  );
};

export default UserMenuIcon;
